import ShippingService from "@/services/ShippingService.js";

export const namespaced = true;

export const state = {
  subtotals: [],
  shipping_orders: [],
  shipping_order_edit: {},
  shipping_scan_edit: {},
  shipping_methods: [],
  delivery_report_line_items: [],
  delivery_status_report_line_items: [],
  delivery_bydate_report_line_items: [],
  active_months: [],
  active_month: {},
  active_mail_tracker_link: "",
  scan_success: false,
  current_ship_method: { ShippingMethodID: 1, ShippingMethodName: "Ground" },
  bigbox_image: "https://dashboard.icap-maker.com/img/shipping/bigbox.jpg",
  smallbox_image: "https://dashboard.icap-maker.com/img/shipping/smallbox.jpg",
  cap_image: "https://dashboard.icap-maker.com/img/shipping/CAP.jpg",
  sticker_image: "https://dashboard.icap-maker.com/img/shipping/Stickers.jpg",
  notecard_image: "https://dashboard.icap-maker.com/img/shipping/Notecard.jpg"
};

export const mutations = {
  SET_SCAN_SUCCESS(state) {
    state.scan_success = true;
  },
  SET_MAILTRACKER(state, mailtracker) {
    state.active_mail_tracker_link = mailtracker;
  },
  SET_SUBTOTALS(state, subtotals) {
    state.subtotals = subtotals;
  },
  SET_SHIPPING_ORDERS(state, orders) {
    state.shipping_orders = orders;
  },
  SET_SHIPPING_ORDER_EDIT(state, order_edit) {
    state.shipping_order_edit = order_edit;
  },
  SET_SHIPPING_SCAN_EDIT(state, scan_edit) {
    state.shipping_scan_edit = scan_edit;
  },
  SET_DELIVERY_REPORT_LINE_ITEMS(state, delivery_report_line_items) {
    state.delivery_report_line_items = delivery_report_line_items;
  },
  SET_DELIVERY_STATUS_REPORT_LINE_ITEMS(
    state,
    delivery_status_report_line_items
  ) {
    state.delivery_status_report_line_items = delivery_status_report_line_items;
  },
  SET_DELIVERY_BYDATE_REPORT_LINE_ITEMS(
    state,
    delivery_bydate_report_line_items
  ) {
    state.delivery_bydate_report_line_items = delivery_bydate_report_line_items;
  },
  SET_ACTIVE_MONTHS(state, active_months) {
    //alert("mutation")
    state.active_months = active_months;
    //alert(state.active_months.length)
    //state.active_month = getters.getCurrentShippingMonth()
    // alert(state.active_month.ShippingMonthID)
    // alert(state.active_months.length)
  },
  SET_METHODS(state, methods) {
    state.shipping_methods = methods;
  }
};

export const getters = {
  SubTotalCount: state => {
    return state.subtotals.length;
  },
  ShippingOrderCount: state => {
    return state.shipping_orders.length;
  },
  getOrderById: state => id => {
    //console.log(state)
    return state.shipping_orders.find(order => order.ShippingOrderID === id);
  },
  getCurrentShippingMonth: state => {
    //alert(state.active_months.length)
    return state.active_months.find(month => month.IsCurrent === true);
  }
};

export const actions = {
  // get_subtotals({ commit }, value) {
  //   return new Promise((resolve, reject) => {
  //     ShippingService.get_subtotals(value)
  //       .then(response => {
  //         state.subtotals = response.data["SubTotalsResult"]
  //         //commit("SET_SUBTOTALS", response.data["SubTotalsResult"])
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         console.log(error.message)
  //         reject(error)
  //       })
  //   })
  // }
  get_mailtracklink({ commit }) {
    return ShippingService.get_mail_tracker_link()
      .then(response => {
        //state.subtotals = response.data["SubTotalsResult"]
        commit("SET_MAILTRACKER", response.data["GetTrackingLinkResult"]);
        //resolve(response)
      })
      .catch(error => {
        console.log(error.message);
        //reject(error)
      });
  },

  get_subtotals({ commit }, value) {
    return ShippingService.get_subtotals(value)
      .then(response => {
        //state.subtotals = response.data["SubTotalsResult"]
        commit("SET_SUBTOTALS", response.data["SubTotalsResult"]);
        //resolve(response)
      })
      .catch(error => {
        console.log(error.message);
        //reject(error)
      });
  },
  get_orders({ commit }, value) {
    return ShippingService.get_ordersByMonth(value)
      .then(response => {
        //state.subtotals = response.data["SubTotalsResult"]
        commit("SET_SHIPPING_ORDERS", response.data["OrdersByMonthResult"]);
        //resolve(response)
      })
      .catch(error => {
        console.log(error.message);
        //reject(error)
      });
  },
  loadShippingOrderEdit({ commit, getters, dispatch }, value) {
    //This is good, use getters first then call api
    // changing it to test progress bars
    {
      return ShippingService.Load_ShippingOrder(value)
        .then(response => {
          commit("SET_SHIPPING_ORDER_EDIT", response.data["ShipmentResult"]);
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  loadScanEdit({ commit, getters, dispatch }, value) {
    {
      return ShippingService.Load_ShippingOrder(value)
        .then(response => {
          commit("SET_SHIPPING_SCAN_EDIT", response.data["ShipmentResult"]);
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  postScan({ commit }, scan) {
    {
      return ShippingService.post_notification(scan)
        .then(response => {
          commit("SET_SCAN_SUCCESS");
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },

  resetScanEdit({ commit }) {
    commit("SET_SHIPPING_SCAN_EDIT", {});
  },
  loadDeliveryReportLineItems({ commit, getters, dispatch }, value) {
    {
      return ShippingService.get_shipMethodReportLines(value)
        .then(response => {
          commit(
            "SET_DELIVERY_REPORT_LINE_ITEMS",
            response.data["ShippingMethodReportResult"]
          );
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  loadDeliveryStatusReportLineItems({ commit, getters, dispatch }, value) {
    {
      return ShippingService.get_shipStatusReportLines(value)
        .then(response => {
          commit(
            "SET_DELIVERY_STATUS_REPORT_LINE_ITEMS",
            response.data["ShippingStatusReportResult"]
          );
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  loadDeliveryByDateReportLineItems({ commit, getters, dispatch }, value) {
    {
      return ShippingService.get_shipByDateReportLines(value)
        .then(response => {
          commit(
            "SET_DELIVERY_BYDATE_REPORT_LINE_ITEMS",
            response.data["ShippedByDateReportResult"]
          );
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  },
  shippingMonths({ commit }) {
    //alert("action")
    return ShippingService.activeMonths()
      .then(response => {
        commit("SET_ACTIVE_MONTHS", response.data);
      })
      .catch(error => {
        console.log(error.message);
      });
  },
  shippingMethods({ commit }) {
    //alert("action")
    return ShippingService.shipMethods()
      .then(response => {
        commit("SET_METHODS", response.data);
      })
      .catch(error => {
        console.log(error.message);
      });
  },
  createDownloadFile({ commit }, op) {
    return ShippingService.CreateDownloadFile(op);
  },
  filterByStatus({ commit }, op) {
    return ShippingService.FilterByStatus(op);
  }
};
